import { Plus, Trash2 } from "lucide-react";
import { C, FRECUENCIA_OPTS, RIESGO_OPTS } from "./constants";
import { PrivacyNote } from "./PrivacyNote";

export const EMPTY_DECISION = { nombre: "", frecuencia: "", riesgo: "" };
const MAX = 12;

const Select = ({ value, onChange, opts, label, testid }) => (
  <label className="flex flex-col gap-1 text-[11px] font-semibold" style={{ color: "#5B6B64" }}>
    {label}
    <select value={value} onChange={(e) => onChange(e.target.value)} className="rounded-lg border bg-white px-2 py-2 text-sm font-normal" style={{ borderColor: "#CBD5CF", color: C.text }} data-testid={testid}>
      <option value="">Elige…</option>
      {opts.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
    </select>
  </label>
);

const Row = ({ d, i, onChange, onRemove, canRemove }) => (
  <div className="rounded-xl bg-white border p-3 grid gap-2 md:grid-cols-[1fr_140px_190px_36px] md:items-start" style={{ borderColor: "#E3E7E1" }} data-testid={`tablero-decision-row-${i}`}>
    <label className="flex flex-col gap-1 text-[11px] font-semibold" style={{ color: "#5B6B64" }}>
      Decisión recurrente
      <input value={d.nombre} maxLength={80} onChange={(e) => onChange({ ...d, nombre: e.target.value })} placeholder="Ej.: aprobar gastos de menos de 500 €" className="rounded-lg border px-3 py-2 text-sm font-normal" style={{ borderColor: "#CBD5CF", color: C.text }} data-testid={`tablero-decision-nombre-${i}`} />
      <PrivacyNote testid={`tablero-privacy-note-decision-${i}`} />
    </label>
    <Select label="Frecuencia" value={d.frecuencia} opts={FRECUENCIA_OPTS} onChange={(v) => onChange({ ...d, frecuencia: v })} testid={`tablero-decision-frecuencia-${i}`} />
    <Select label="Riesgo si decide otra persona" value={d.riesgo} opts={RIESGO_OPTS} onChange={(v) => onChange({ ...d, riesgo: v })} testid={`tablero-decision-riesgo-${i}`} />
    <button type="button" onClick={onRemove} disabled={!canRemove} className="md:mt-5 h-9 w-9 inline-flex items-center justify-center rounded-lg border disabled:opacity-30" style={{ borderColor: "#CBD5CF" }} aria-label="Quitar decisión" data-testid={`tablero-decision-remove-${i}`}>
      <Trash2 className="w-4 h-4" style={{ color: C.text }} />
    </button>
  </div>
);

export const DecisionesEditor = ({ decisiones, setDecisiones }) => (
  <div className="space-y-2" data-testid="tablero-decisiones-editor">
    {decisiones.map((d, i) => (
      <Row key={i} d={d} i={i} onChange={(nd) => setDecisiones(decisiones.map((x, j) => (j === i ? nd : x)))} onRemove={() => setDecisiones(decisiones.filter((_, j) => j !== i))} canRemove={decisiones.length > 5} />
    ))}
    {decisiones.length < MAX && (
      <button type="button" onClick={() => setDecisiones([...decisiones, { ...EMPTY_DECISION }])} className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: C.green }} data-testid="tablero-decision-add">
        <Plus className="w-4 h-4" /> Añadir decisión ({decisiones.length} de {MAX})
      </button>
    )}
  </div>
);

export const decisionesValid = (ds) => ds.length >= 5 && ds.length <= MAX && ds.every((d) => d.nombre.trim() && d.frecuencia && d.riesgo);
